import { useState } from 'react';
import "./ButtonGroup.scss";
import { Box } from '@mui/material';


const ButtonGroup = ({ buttons, handleOnChange }) => {
  const [clickedId, setClickedId] = useState(-1);

  const handleClick = (event, id, buttonLabel) => {
    setClickedId(id);
    handleOnChange(event, buttonLabel);
  };

  return( 
    <Box className='button-grp-container'>
      {buttons.map((buttonLabel, i) => (
        <button
          key={i}
          name={buttonLabel}
          onClick={(event) => handleClick(event, i, buttonLabel)}
          className={i === clickedId ? "customButton active" : "customButton"}
        >
          {buttonLabel}
        </button>
      ))}
    </Box>
  );
};

export default ButtonGroup;